// Order figures come back from the ledger as raw floats, so values like
// 329.9999999999999 were being printed in full. Cut the tail off at 2 decimal
// places instead of rounding it, so a displayed figure is never higher than the
// real one. Whole numbers are left alone (10 stays "10", not "10.00").
//
// Scoped to the single order view on purpose - other screens keep their own
// formatting.
export const formatDecimal = (value, maxDecimals = 2) => {
  if (value === null || value === undefined || value === '') return 'N/A';

  const number = Number(value);
  // Non-numeric text (an already-resolved 'N/A', say) is passed straight
  // through; a genuine NaN has nothing to show.
  if (Number.isNaN(number)) return typeof value === 'number' ? 'N/A' : value;
  if (Number.isInteger(number)) return number.toLocaleString();

  const truncate = decimals => {
    const factor = 10 ** decimals;
    return Math.trunc(number * factor) / factor;
  };

  let truncated = truncate(maxDecimals);
  let decimals = maxDecimals;

  // A sub-cent figure (a per-unit fee, say) would truncate to a misleading
  // "0.00", so keep enough decimals to show it is not actually zero.
  while (truncated === 0 && decimals < 8) {
    decimals += 1;
    truncated = truncate(decimals);
  }

  return truncated.toLocaleString(undefined, {
    minimumFractionDigits: Math.min(maxDecimals, decimals),
    maximumFractionDigits: decimals,
  });
};

// Same rules, prefixed with the order's currency.
export const formatDecimalWithCurrency = (value, currency) => {
  const formatted = formatDecimal(value);
  return formatted === 'N/A' ? 'N/A' : `${currency} ${formatted}`;
};
